import React from 'react';
import { Form } from 'semantic-ui-react';

/**
 * datetime-local uses the document/input locale for its empty-state UI.
 * Wrap with lang="en" so browsers show YYYY-MM-DD instead of 年-月-日.
 */
export function DatetimeLocalInput({ input = {}, ...rest }) {
  return (
    <div lang='en' className='rp-datetime-local-en'>
      <Form.Input
        {...rest}
        type='datetime-local'
        input={{ lang: 'en', ...input }}
      />
    </div>
  );
}
